// extracted by mini-css-extract-plugin
export default {"header":"SatisfactionHealth_header__Mr5Y8","charts":"SatisfactionHealth_charts__-o7La"};